'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _WalletSelection = require('./WalletSelection');

var _WalletSelection2 = _interopRequireDefault(_WalletSelection);

var _UnSuppportedWalletModal = require('./UnSuppportedWalletModal');

var _UnSuppportedWalletModal2 = _interopRequireDefault(_UnSuppportedWalletModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WalletSelectionContainer = function (_React$Component) {
  _inherits(WalletSelectionContainer, _React$Component);

  function WalletSelectionContainer(props) {
    _classCallCheck(this, WalletSelectionContainer);

    var _this = _possibleConstructorReturn(this, (WalletSelectionContainer.__proto__ || Object.getPrototypeOf(WalletSelectionContainer)).call(this, props));

    _this.state = {
      walletType: '',
      isSupported: true
    };

    _this.handleWalletTypeSelect = _this.handleWalletTypeSelect.bind(_this);
    _this.handleWalletOptionsSubmit = _this.handleWalletOptionsSubmit.bind(_this);
    _this.resetWalletSelection = _this.resetWalletSelection.bind(_this);
    _this.handleUnsupportedWalletBackClick = _this.handleUnsupportedWalletBackClick.bind(_this);
    return _this;
  }

  _createClass(WalletSelectionContainer, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.walletType !== nextState.walletType || this.state.isSupported !== nextState.isSupported || this.props.walletDefinitions !== nextProps.walletDefinitions || this.props.onWalletSelect !== nextProps.onWalletSelect || this.props.givenProvider !== nextProps.givenProvider || this.props.onWalletIsSupported !== nextProps.onWalletIsSupported) {
        return true;
      }
      return false;
    }
  }, {
    key: 'handleWalletTypeSelect',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(walletType) {
        var _this2 = this;

        var _props, walletDefinitions, givenProvider, onWalletIsSupported, walletDefinition, isSupported;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, walletDefinitions = _props.walletDefinitions, givenProvider = _props.givenProvider, onWalletIsSupported = _props.onWalletIsSupported;
                walletDefinition = walletDefinitions.find(function (definition) {
                  return definition.type === walletType;
                });

                if (!walletDefinition) {
                  _context.next = 14;
                  break;
                }

                isSupported = void 0;

                if (!onWalletIsSupported) {
                  _context.next = 10;
                  break;
                }

                _context.next = 7;
                return onWalletIsSupported(walletType, givenProvider);

              case 7:
                isSupported = _context.sent;
                _context.next = 13;
                break;

              case 10:
                _context.next = 12;
                return walletDefinition.isSupported(givenProvider);

              case 12:
                isSupported = _context.sent;

              case 13:
                if (isSupported) {
                  this.setState({ isSupported: isSupported, walletType: walletType }, function () {
                    // No options needed, we can finish wallet selection now.
                    if (!walletDefinition.getOptionsComponent()) {
                      _this2.props.onWalletSelect(walletType, {});
                    }
                  });
                } else {
                  this.setState({ isSupported: isSupported, walletType: walletType });
                }

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleWalletTypeSelect(_x) {
        return _ref.apply(this, arguments);
      }

      return handleWalletTypeSelect;
    }()
  }, {
    key: 'handleWalletOptionsSubmit',
    value: function handleWalletOptionsSubmit(walletOptions) {
      // Finish wallet selection if we have options.
      if (!(0, _lodash.isEmpty)(walletOptions)) {
        this.props.onWalletSelect(this.state.walletType, walletOptions);
      } else {
        // No options - user cancelled, re-select wallet.
        this.setState({ walletType: '' });
      }
    }
  }, {
    key: 'resetWalletSelection',
    value: function resetWalletSelection() {
      this.setState({ isSupported: false, walletType: '' });
    }
  }, {
    key: 'handleUnsupportedWalletBackClick',
    value: function handleUnsupportedWalletBackClick() {
      this.resetWalletSelection();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isSupported = _state.isSupported,
          walletType = _state.walletType;

      if (!isSupported && walletType) {
        return _react2.default.createElement(_UnSuppportedWalletModal2.default, {
          walletType: walletType,
          onBack: this.handleUnsupportedWalletBackClick
        });
      }
      if (walletType) {
        var walletDefinitions = this.props.walletDefinitions;

        var walletDefinition = walletDefinitions.find(function (definition) {
          return definition.type === walletType;
        });
        var OptionsComponent = walletDefinition.getOptionsComponent();
        if (OptionsComponent) {
          return _react2.default.createElement(OptionsComponent, { onSubmit: this.handleWalletOptionsSubmit });
        }
      }
      return _react2.default.createElement(_WalletSelection2.default, {
        walletDefinitions: this.props.walletDefinitions,
        onClick: this.handleWalletTypeSelect
      });
    }
  }]);

  return WalletSelectionContainer;
}(_react2.default.Component);

WalletSelectionContainer.defaultProps = {
  walletDefinitions: [],
  onWalletSelect: _lodash.noop,
  givenProvider: null,
  onWalletIsSupported: null
};


WalletSelectionContainer.propTypes = {
  walletDefinitions: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  onWalletSelect: _propTypes2.default.func,
  onWalletIsSupported: _propTypes2.default.func,
  givenProvider: _propTypes2.default.shape({})
};

exports.default = WalletSelectionContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/wallet/WalletSelectionContainer.js
// module id = 469
// module chunks = 0